/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![CalendarRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABhElEQVR4nN1VO0sDQRAOFmKTJkb9H9qlsdMgN48rNjMRQ/6AFgb7gIUm/0dBUBQM/hQfjbGwEC0S2fUOkjtyj+REcGBg2Z2dbx7fzpZKfyXA+oAkg6LspmS73V5B1rFVu17UzokxZhlZ+kDyFF7Kq8DyiKw96ysGYA/mdYxx7cVruUDkGFXS53gGJIOiAID1vvT/BCyfC+uBxN9FgQwaW/1tgFEigDGmEu4bYyqzHckLkJ4z72/5/sE6IpaJpOax7CQCZMkOWC4nA0mVPABActHtdpccOXytA8sVsgyB9B1Zb4gau7EhOOmAubUa7jO3VqNlCc+R9TRzs3NQ8MzaEzX3gmy+kKXjec2qVUQ9BtLPuQE8v7HpSsN6HWTUSXpLuQE4KA+QvjpAr1mdNc+mZlIwy9NBEMs/Ackw2q80FmX6D4ikFpTjLlqiDD+a9lIyGdnmuoBQMWyyR3ICoBt1Y9bcmuUNWA4zASdnLf1ZwQDp0cIAVoCFgPXW0ZXkw7LLPr7Q4Bu/7mVG0zDbvwAAAABJRU5ErkJggg==)
 */
export const CalendarRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M19 16a3 3 0 1 0 1.98 5.25 1 1 0 1 1 1.33 1.5A4.98 4.98 0 0 1 14 19a5 5 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 1 1 0-2h1.24a3 3 0 0 0-1.29-.85M19 16c.17 0 .34.01.5.04L19 16Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path d="M19.95 16.15v.01l-.44-.12" fill={typeof color === 'string' ? color : color.css} className={colorClass} />
      <path
        fillRule="evenodd"
        d="M22 11.82V10a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a3 3 0 0 0 3 3h6.88c.37 0 .61-.38.5-.73a7 7 0 0 1 8.83-8.91c.15.05.3.03.44-.04l.02-.01c.2-.1.33-.28.33-.5ZM5 12.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M8 2a1 1 0 1 0-2 0v.75c0 .14-.11.25-.25.25H5a3 3 0 0 0-3 3 1 1 0 0 0 1 1h18a1 1 0 0 0 1-1 3 3 0 0 0-3-3h-.75a.25.25 0 0 1-.25-.25V2a1 1 0 1 0-2 0v.75c0 .14-.11.25-.25.25h-7.5A.25.25 0 0 1 8 2.75V2Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
